<template >
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">
      <div class="">
        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">
                      <div v-if="department && program">
                        {{ department.name }}/{{ program.name }}
                      </div>
                      <span>Сурагч нэмэх/засаx</span>
                    </h1>
                  </div>
                  <form class="user">
                    <div class="row">
                      <div class="col-md-6 col-sm-12 form-group">
                        <label>Нэр</label>
                        <input
                          v-model.trim="student.name"
                          type="text"
                          class="form-control"
                          id="exampleInputEmail"
                          aria-describedby="emailHelp"
                          placeholder="Нэр"
                        />
                      </div>
                      <div class="col-md-6 col-sm-12 form-group">
                        <label>Овог</label>
                        <input
                          v-model.trim="student.lastname"
                          type="text"
                          class="form-control"
                          id="exampleInputEmail"
                          aria-describedby="emailHelp"
                          placeholder="Овог"
                        />
                      </div>
                      <div class="col-md-6 col-sm-12 form-group">
                        <label>Овгийн үсэг таслах тоо</label>
                        <p class="explanationText">
                          Ижил овогтой сурагчдыг ялгаx овог таслаx тоо
                        </p>
                        <input
                          v-model.number="student.lncount"
                          type="number"
                          class="form-control"
                          placeholder="Овгийн үсэг таслах тоо"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 col-sm-12 form-group text-danger">
                        <!-- v-if="student.id==null || student.id==undefined" -->
                        <label>Сурагчийн код</label>
                        <input
                          v-model.trim="student.code"
                          type="text"
                          class="form-control"
                          placeholder=""
                        />
                      </div>
                      <div class="col-md-6 col-sm-12 form-group text-danger">
                        <label
                          >Регистрийн
                          <span class="explanationText text-danger"
                            >(Үсгийн том жижиг xамааралгүй)</span
                          ></label
                        >
                        <input
                          v-model.trim="student.register"
                          type="text"
                          class="form-control"
                          placeholder=""
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col form-group">
                        <label>Утасны дугаар 1</label>
                        <input
                          v-model.trim="student.phone"
                          type="text"
                          class="form-control"
                          placeholder=" "
                        />
                      </div>
                      <div class="col form-group">
                        <label>Утасны дугаар 2</label>
                        <input
                          v-model.trim="student.phone2"
                          type="text"
                          class="form-control"
                          placeholder=""
                        />
                      </div>
                      <div class="col-md-6 col-sm-12 form-group">
                        <label>Имэйл</label>
                        <input
                          v-model.trim="student.email"
                          type="text"
                          class="form-control"
                          placeholder=""
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="row justify-content-start">
                        <div class="col-md-6 col-sm-12">
                          <div class="form-group">
                            <div class="radio">
                              <label
                                ><input
                                  type="radio"
                                  name="gendergroup"
                                  :value="0"
                                  v-model="student.gender"
                                />
                                Эр</label
                              >
                            </div>
                            <div class="radio">
                              <label
                                ><input
                                  type="radio"
                                  name="gendergroup"
                                  :value="1"
                                  v-model="student.gender"
                                />
                                Эм</label
                              >
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                          <div class="form-group">
                            <div class="radio">
                              <label
                                ><input
                                  type="radio"
                                  name="typegroup"
                                  value="shift"
                                  v-model="student.type"
                                  v-bind:checked="
                                    student.type && student.type == 'shift'
                                      ? 'checked'
                                      : ''
                                  "
                                />
                                Шилжиж ирсэн</label
                              >
                            </div>
                            <div class="radio">
                              <label
                                ><input
                                  type="radio"
                                  name="typegroup"
                                  value="new"
                                  v-model="student.type"
                                  v-bind:checked="
                                    student.type && student.type == 'new'
                                      ? 'checked'
                                      : ''
                                  "
                                />
                                Шинэ</label
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <div class="row justify-content-end">
                        <p
                          @click="showDetail = !showDetail"
                          class="calllink text-primary"
                        >
                          Нэмэлт мэдээлэл оруулаx
                          <i v-if="showDetail" class="fas fa-angle-up"></i>
                          <i v-else class="fas fa-angle-down"></i>
                        </p>
                      </div>
                    </div>
                    <div v-if="showDetail">
                      <div v-if="student.birth">
                        <div class="text-center font-weight-bold">
                          Төрсөн огноо
                        </div>
                        <div class="row">
                          <div class="col">
                            <div class="form-group">
                              <label for="exampleFormControlSelect1"
                                >Төрсөн он</label
                              >
                              <select
                                class="form-control"
                                v-model="student.birth.year"
                              >
                                <option
                                  v-for="year in years"
                                  v-bind:value="year"
                                >
                                  {{ year }} он
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col" v-if="school != null">
                            <div class="form-group">
                              <label for="exampleFormControlSelect1"
                                >Төрсөн сар</label
                              >
                              <select
                                class="form-control"
                                v-model="student.birth.month"
                              >
                                <option
                                  v-for="month in months"
                                  v-bind:value="month"
                                >
                                  {{ month }} сар
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col" v-if="school != null">
                            <div class="form-group">
                              <label for="exampleFormControlSelect1"
                                >Төрсөн өдөр</label
                              >
                              <select
                                class="form-control"
                                v-model="student.birth.day"
                              >
                                <option v-for="day in days" v-bind:value="day">
                                  {{ day }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div v-if="student.iaddress">
                        <div class="text-center font-weight-bold">
                          Оршин суугаа хаяг
                        </div>
                        <div class="row">
                          <div class="col">
                            <div class="form-group">
                              <label for="exampleFormControlSelect1"
                                >Хот:
                              </label>
                              <select class="form-control" v-model="city">
                                <option
                                  v-for="(school, index) in cities"
                                  v-bind:key="school.id"
                                  v-bind:value="school"
                                >
                                  {{ index + 1 }}. {{ school.data().name }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col" v-if="city">
                            <div class="form-group">
                              <label for="exampleFormControlSelect1"
                                >Дүүрэг/Сум:
                              </label>
                              <select class="form-control" v-model="district">
                                <option
                                  v-for="(dep, index) in city.districts"
                                  v-bind:key="dep.id"
                                  v-bind:value="dep"
                                >
                                  {{ index + 1 }}. {{ dep.data().name }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div class="row" v-if="district">
                          <div class="col">
                            <div class="form-group">
                              <label for="exampleFormControlSelect1"
                                >Хороо/баг/:
                              </label>
                              <input
                                v-model.trim="student.iaddress.horoo"
                                type="text"
                                class="form-control"
                                placeholder="Хороо/баг/"
                              />
                            </div>
                          </div>
                          <div class="col">
                            <div class="form-group">
                              <label for="exampleFormControlSelect1"
                                >Байшин хашаа:
                              </label>
                              <input
                                v-model.trim="student.iaddress.building"
                                type="text"
                                class="form-control"
                                placeholder="Байшин хашаа"
                              />
                            </div>
                          </div>
                          <div class="col">
                            <div class="form-group">
                              <label for="exampleFormControlSelect1"
                                >Тоот:
                              </label>
                              <input
                                v-model.trim="student.iaddress.entrynumber"
                                type="text"
                                class="form-control"
                                placeholder="Тоот"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div>
                        <div class="text-center font-weight-bold">Хаанаас</div>
                        <div class="row">
                          <div class="col">
                            <div class="form-group">
                              <label for="exampleFormControlSelect1"
                                >Хот:
                              </label>
                              <select class="form-control" v-model="city1">
                                <option
                                  v-for="(school, index) in cities"
                                  v-bind:key="school.id"
                                  v-bind:value="school"
                                >
                                  {{ index + 1 }}. {{ school.data().name }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col" v-if="city1">
                            <div class="form-group">
                              <label for="exampleFormControlSelect1"
                                >Дүүрэг/Сум:
                              </label>
                              <select class="form-control" v-model="district1">
                                <option
                                  v-for="(dep, index) in city.districts"
                                  v-bind:key="dep.id"
                                  v-bind:value="dep"
                                >
                                  {{ index + 1 }}. {{ dep.data().name }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="form-group" v-if="district1">
                          <label for="exampleFormControlSelect1"
                            >Сургууль:
                          </label>
                          <input
                            v-model.trim="student.preschool.schoolname"
                            type="text"
                            class="form-control"
                            placeholder="Сургууль"
                          />
                        </div>
                      </div>
                    </div>

                    <hr />

                    <div class="row">
                      <div class="text-center col">
                        <a
                          class="text-primary"
                          style="cursor: pointer"
                          @click="$router.back()"
                          >Буцах</a
                        >
                      </div>
                      <div class="col" v-if="enabled == true">
                        <div @click="save" class="btn btn-primary">
                          Хадгалах
                        </div>
                      </div>
                    </div>
                    <hr />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../firebaseConfig.js");
import { mapState } from "vuex";
export default {
  name: "ProgramStudentAdd",
  data() {
    return {
      showDetail: false,
      student: {
        name: "",
        lastname: "",
        phone: "",
        phone2: "",
        code: "",
        email: "",
        address: "",
        register: "",
        birth: {
          year: null,
          month: null,
          day: null,
        },
        iaddress: {
          city: null,
          district: null,
          horoo: null,
          building: null,
          entrynumber: null,
        },
        preschool: {
          city: null,
          district: null,
          schoolname: null,
        },
        gender: null,
        type: null,
        lncount: null,
      },
      performingRequest: false,
      schools: [],
      school: null,
      department: null,
      program: null,
      years: [],
      months: [],
      days: [],
      cities: [],
      city: null,
      district: null,
      city1: null,
      district1: null,
      enabled: false,
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  methods: {
    save() {
      this.performingRequest = true;
      if (
        this.student != null &&
        this.student.name != "" &&
        this.student.code != ""
      ) {
        if (
          this.student.id != null &&
          this.student.id != "" &&
          this.student.id != "new"
        ) {
          this.student.modified = fb.usersCollection.doc(
            this.$store.getters.currentUser.uid
          );
          this.student.modifiedAt = new Date();
          if (this.schoolId) {
            this.student.school = fb.db
              .collection("schools")
              .doc(this.schoolId);
            if (this.departmentId) {
              this.student["department-" + this.department.startYear] =
                this.department.ref;
              if (this.programId != null)
                this.student["program-" + this.department.startYear] =
                  this.program.ref;
            }
          }

          if (this.city) {
            this.student.iaddress.cityName = this.city.data().name;
            this.student.iaddress.city = this.city.ref;
          }
          if (this.district!=null&&this.district!==undefined) {
            // this.student.iaddress.districtName = this.district.data().name;
            // this.student.iaddress.district = this.district.ref;
            //XTODO
          }

          if (this.city1) {
            this.student.preschool.cityName = this.city1.data().name;
            this.student.preschool.city = this.city1.ref;
          }
          if (this.district1) {
            this.student.preschool.districtName = this.district1.data().name;
            this.student.preschool.district = this.district1.ref;
          }

          fb.db
            .collection("schools/" + this.schoolId + "/students")
            .doc(this.student.id)
            .set(this.student);
 
          this.$router.back();
        } else {
          this.student.code = this.student.code.toLowerCase();
          this.student.register = this.student.register.toLowerCase();
          fb.db
            .collection("schools/" + this.schoolId + "/students")
            .where("register", "==", this.student.register)
            .limit(1)
            .get()
            .then((sts) => {
              if (sts.empty == true) {
                this.student.created = fb.usersCollection.doc(
                  this.$store.getters.currentUser.uid
                );
                this.student.createdAt = new Date();
                if (this.schoolId) {
                  this.student.school = fb.db
                    .collection("schools")
                    .doc(this.schoolId);
                  fb.db
                    .collection("schools")
                    .doc(this.schoolId)
                    .update({
                      numberOfStudents: fb.firestore.FieldValue.increment(1),
                    });
                  if (this.departmentId) {
                    this.student["department-" + this.department.startYear] =
                      this.department.ref;

                    if (this.programId != null) {
                      this.student["program-" + this.department.startYear] =
                        this.program.ref;
                    }
                  }
                }
                if (this.city) {
                  this.student.iaddress.cityName = this.city.data().name;
                  this.student.iaddress.city = this.city.ref;
                }
                if (this.district) {
                  this.student.iaddress.districtName =
                    this.district.data().name;
                  this.student.iaddress.district = this.district.ref;
                }

                if (this.city1) {
                  this.student.preschool.cityName = this.city1.data().name;
                  this.student.preschool.city = this.city1.ref;
                }
                if (this.district1) {
                  this.student.preschool.districtName =
                    this.district1.data().name;
                  this.student.preschool.district = this.district1.ref;
                }
                fb.db
                  .collection("schools/" + this.schoolId + "/students")
                  .doc()
                  .set(this.student)
                  .then(() => {
                    this.student[
                      "department-" + this.department.startYear
                    ].update({
                      numberOfStudents: fb.firestore.FieldValue.increment(1),
                    });

                    this.student["program-" + this.department.startYear].update(
                      {
                        numberOfStudents: fb.firestore.FieldValue.increment(1),
                      }
                    );
                    alert("Сурагч амжилттай бүртгэгдлээ.");
                  });

                this.$router.back();
              } else {
                alert(
                  this.student.register +
                    " регистрийн дугаартай сурагч бүртгэлтэй байна."
                );
              }
            });
        }
      }
    },
    setStudent() {
      this.student = {
        name: "",
        lastname: "",
        phone: "",
        phone2: "",
        code: "",
        email: "",
        address: "",
      };
    },

    remove(index, array) {
      if (array != null && array.length > 0) array.splice(index, 1);
    },

    _getcities() {
      fb.db
        .collection("cities")
        .orderBy("name", "asc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((schoolData) => {
            this._getDistricts(schoolData.id, schoolData);
            this.cities.push(schoolData);
            if (
              this.student.iaddress &&
              this.student.iaddress.city &&
              this.student.iaddress.city.path == schoolData.ref.path
            ) {
              this.city = schoolData;
            }
            if (
              this.student.preschool &&
              this.student.preschool.city &&
              this.student.preschool.city.path == schoolData.ref.path
            ) {
              this.city1 = schoolData;
            }
          });
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },
    _getDistricts(schoolId, schoolData) {
      schoolData.ref
        .collection("districts")
        .orderBy("name", "asc")
        .get()
        .then((querySnapshot) => {
          let deps = [];
          querySnapshot.forEach((depdata) => {
            deps.push(depdata);
            if (
              this.student.iaddress &&
              this.student.iaddress.district &&
              this.student.iaddress.district.path == depdata.ref.path
            ) {
              this.district = depdata;
            }
            if (
              this.student.preschool &&
              this.student.preschool.district &&
              this.student.preschool.district.path == depdata.ref.path
            ) {
              this.district1 = depdata;
            }
          });
          schoolData.districts = deps;
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },
    async _getStudent() {
      var departmentDoc = await fb.db
        .collection("schools/" + this.schoolId + "/departments")
        .doc(this.departmentId)
        .get();
      if (departmentDoc && departmentDoc.exists) {
        var programDoc = await departmentDoc.ref
          .collection("programs")
          .doc(this.programId)
          .get();
        if (programDoc && programDoc.exists) {
          let dep = departmentDoc.data();
          dep.id = departmentDoc.id;
          dep.ref = departmentDoc.ref;
          this.department = dep;

          let pro = programDoc.data();
          pro.id = programDoc.id;
          pro.ref = programDoc.ref;
          this.program = pro;

          this.enabled = true;
          if (
            this.studentId != null &&
            this.studentId != "" &&
            this.studentId != "new"
          ) {
            fb.db
              .collection("schools/" + this.schoolId + "/students")
              .doc(this.studentId)
              .get()
              .then((studentData) => {
                let object = studentData.data();
                object.id = studentData.id;
                this.student = object;
                if (!this.student.birth) {
                  this.student.birth = {
                    year: null,
                    month: null,
                    day: null,
                  };
                }
                if (!this.student.iaddress) {
                  this.student.iaddress = {
                    city: null,
                    district: null,
                    horoo: null,
                    building: null,
                    entrynumber: null,
                  };
                }
                if (!this.student.preschool) {
                  this.student.preschool = {
                    city: null,
                    district: null,
                    schoolname: null,
                  };
                }
                if (this.student.gender == undefined)
                  this.student.gender = null;
                if (!this.student.type) this.student.type = null;
                if (!this.student.lncount) {
                  this.student.lncount = null;
                }

                this._getcities();
              });
          } else this._getcities();
        }
      }
    },
  },
  props: {
    studentId: {
      required: false,
    },
    schoolId: {
      requered: true,
    },
    departmentId: {
      required: true,
    },
    programId: {
      required: true,
    },
  },
  created() {
    for (var i = 1970; i <= 2005; i++) {
      this.years.push(i);
    }
    for (var i = 1; i <= 12; i++) {
      this.months.push(i);
    }
    for (var i = 1; i <= 31; i++) {
      this.days.push(i);
    }
    if (this.schoolId && this.departmentId && this.programId) {
      this._getStudent();
    }
  },
};
</script>

